import React from 'react';
import {Button, Input, Modal, Table, message} from 'antd';
import {getNewOutlet, getOutlet, useOutlet} from 'reconnect.js';
import * as Jstorage from '../../JStorage';
import * as AppActions from '../../AppActions';

getNewOutlet('admin-search-product-modal', null, {autoDelete: false});

export function showAdminSearchProductModal(data) {
  getOutlet('admin-search-product-modal').update(data);
}

export default function AdminSearchProductModal(props) {
  const [data, setData] = useOutlet('admin-search-product-modal');
  const [records, setRecords] = React.useState(null);
  // const [_selectedRows, _setSelectedRows] = React.useState([]);
  const [filters, setFilters] = React.useState({
    keyword: '',
    pageSize: 4,
    page: 1,
  });
  const [total, setTotal] = React.useState(0);

  const columns = React.useMemo(() => {
    return [
      {
        key: 'name',
        title: '名稱',
        dataIndex: 'name',
      },
      {
        key: 'type',
        title: '類型',
        dataIndex: 'type',
        render: (_, item) => {
          if (item['type'] === 'group_root') {
            return '商品集合母項';
          } else if (item['type'] === 'group_item') {
            return '商品集合子項';
          }
          return '商品';
        },
      },
      {
        key: 'price',
        title: '價錢',
        dataIndex: 'price',
      },
      {
        key: '',
        title: '',
        dataIndex: '',
        render: (_, item) => {
          return (
            <Button
              onClick={() => {
                data.onChange(item.id);
                onClose();
              }}>
              選擇
            </Button>
          );
        },
      },
    ];
  }, [data?.onChange]);

  function onClose() {
    setFilters({keyword: '', pageSize: 4, page: 1});
    setRecords([]);
    setData(null);
  }

  const fetchRecords = React.useCallback(async () => {
    try {
      AppActions.setLoading(true);

      let {total, results} = await Jstorage.fetchDocuments(
        'product',
        {
          $or: columns
            .filter((c) => !!c.key)
            .map((column) => ({
              [column.key]: {$regex: filters.keyword || ''},
            })),
        },
        null,
        {
          offset: (filters.page - 1) * filters.pageSize,
          limit: filters.pageSize,
        },
      );
      setRecords(results);
      setTotal(total);
    } catch (err) {
      console.log('err', err);
      message.error('發生錯誤。');
    } finally {
      AppActions.setLoading(false);
    }
  }, [filters, columns]);

  React.useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  return (
    <Modal
      open={!!data}
      onCancel={onClose}
      footer={null}
      width={1000}
      closable={false}
      maskClosable={true}
      destroyOnClose={true}>
      <div>
        <Input.Search
          style={{marginBottom: 10}}
          placeholder="請輸入關鍵字"
          allowClear
          onSearch={(value) => {
            setFilters((prev) => ({
              ...prev,
              keyword: value,
              page: 1,
              pageSize: 4,
            }));
          }}
        />

        <Table
          style={{marginBottom: 10}}
          scroll={{x: 500, y: 300}}
          pagination={{
            pageSize: filters.pageSize,
            current: filters.page,
            total: total,
            onChange: async (page, pageSize) => {
              setFilters((prev) => ({...prev, page, pageSize}));
            },
          }}
          /*
          rowKey={(record) => record.owner}
          rowSelection={{
            type: 'radio',
            onChange: (selectedRowKeys, selectedRows) => {
              _setSelectedRows(selectedRows);
            },
          }}
          */
          columns={columns}
          dataSource={records}
        />
      </div>
    </Modal>
  );
}
